enum ShiftItemCategory {
  MISSING_CBH_DOCUMENTS = "MISSING_CBH_DOCUMENTS",
  BOOKING_WARNING = "BOOKING_WARNING",
  WAITING_FOR_APPROVE = "WAITING_FOR_APPROVE",
  NOT_READY_TO_BOOK_SHIFT = "NOT_READY_TO_BOOK_SHIFT",
  /**
   * We need to inform to HCP when they're booking at instantpay shift
   */
  WELCOME_TO_INSTANTPAY = "WELCOME_TO_INSTANTPAY",
  NO_LOCATION_PERMISSION = "NO_LOCATION_PERMISSION",
  // documents are expiring before end of a shift
  MISSING_CBH_DOCUMENTS_BEFORE_A_SHIFT_END = "MISSING_CBH_DOCUMENTS_BEFORE_A_SHIFT_END",
  OVERWORK_BOOKING = "OVERWORK_BOOKING",
  // these are used with the experimental - now dead - onboarding workflows but are referenced
  STRIPE_NOT_CONNECTED_AND_MISSING_HCP_DOCUMENTS = "STRIPE_NOT_CONNECTED_AND_MISSING_HCP_DOCUMENTS",
  STRIPE_NOT_CONNECTED_AND_MISSING_CBH_DOCUMENTS_BEFORE_A_SHIFT_END = "STRIPE_NOT_CONNECTED_AND_MISSING_CBH_DOCUMENTS_BEFORE_A_SHIFT_END",
}

interface ToolTipProps {
  toolTipHandler?: Function;
  content: any;
  buttonName?: string;
  toolTipClass?: string;
}

export interface CbhDocument {
  reqId: string;
  name: string;
  visibleToHCP: boolean;
}

export { ToolTipProps, ShiftItemCategory };
